import { render, staticRenderFns } from "./VideoWithCover.vue?vue&type=template&id=56b2aa60&scoped=true"
import script from "./VideoWithCover.vue?vue&type=script&lang=js"
export * from "./VideoWithCover.vue?vue&type=script&lang=js"
import style0 from "./VideoWithCover.vue?vue&type=style&index=0&id=56b2aa60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2aa60",
  null
  
)

export default component.exports